module.exports = __webpack_public_path__ + "static/logo-61f3948dc312b708afa631096ac44338.png";